import React, { useRef, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import { DarkTheme } from "./Themes";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";
import { Work } from "../data/WorkData";
import Card from "../subComponents/Card";
import { YinYang } from "./AllSvgs";
import BigTitlte from "../subComponents/BigTitlte";

/* ================= PAGE WRAPPER ================= */

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

/* ================= HORIZONTAL SCROLL ================= */

const ScrollContainer = styled.div`
  display: flex;
  gap: 3rem;
  padding: 0 20vw;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;

  width: 100%;
  height: 70vh;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }
`;

/* ================= CARD WRAPPER ================= */

const CardWrapper = styled.div`
  flex: 0 0 380px;
  scroll-snap-align: center;
  display: flex;
  justify-content: center;
`;

/* ================= YINYANG ================= */

const Rotate = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  width: 50px;
  height: 50px;
  z-index: 10;
  transition: transform 0.1s linear;
`;

/* ================= COMPONENT ================= */

const WorkPage = () => {

  const scrollRef = useRef(null);
  const yinRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;

    const handleScroll = () => {
      const scrollAmount = container.scrollLeft;
      yinRef.current.style.transform = `rotate(${scrollAmount * 0.3}deg)`;
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />

        <ScrollContainer ref={scrollRef}>
          {Work.map((d) => (
            <CardWrapper key={d.id}>
              <Card data={d} />
            </CardWrapper>
          ))}
        </ScrollContainer>

        <Rotate ref={yinRef}>
          <YinYang width={50} height={50} fill={DarkTheme.text} />
        </Rotate>

        <BigTitlte text="WORK" top="6%" right="20%" />
        <BigTitlte text="SWIPE.." top="80%" right="20%" />
      </Box>
    </ThemeProvider>
  );
};

export default WorkPage;